import { render, staticRenderFns } from "./PayMethod.vue?vue&type=template&id=1d2c19e1&scoped=true"
import script from "./PayMethod.vue?vue&type=script&lang=js"
export * from "./PayMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2c19e1",
  null
  
)

export default component.exports